<script lang="ts">
    import { onMount } from "svelte";
    import { Heading } from "flowbite-svelte";
    import { DateTime } from "luxon";
    import * as Sentry from "@sentry/svelte";
    import posthog from "posthog-js";
    import DarModal from "./DarModal.svelte";
    import NotificationModal from "./NotificationModal.svelte";
    import { State } from "../state.svelte";
    import { Helper } from "../helpers";

    let time: DateTime = $state(DateTime.now());
    let timeString = $state(getTimeString());
    let dateString = $state(getDateString());

    let showNotificationsModal: boolean = $state(false);
    let triggeredNotification: boolean = $state(false);

    let darModal: boolean = $state(false);
    let triggeredDarModal: boolean = $state(false);

    onMount(async () => {
        if ("Notification" in window) {
            State.options.notificationPermission = Notification.permission === "granted";

            if (Notification.permission === "default")
                showNotificationsModal = true;

        } else {
            Sentry.captureMessage("Notifications not supported", "info");
        }
    });

    function getTimeString() {
        const timeFormat = "HH:mm:ss";
        return time.setZone("America/Denver").toFormat(timeFormat);
    }

    function getDateString() {
        const dateFormat = "MM/dd/yyyy";
        return time.setZone("America/Denver").toFormat(dateFormat);
    }

    let darModalInterval: NodeJS.Timeout | null = $state(null);

    function openDarModal() {
        darModal = true;
        darModalInterval = setInterval(() => {
            Helper.toggleCurrentTheme();
        }, 800);
    }

    function closeDarModal() {
        darModal = false;

        if (darModalInterval)
            clearInterval(darModalInterval);

        darModalInterval = null;
        Helper.resetCurrentTheme();
        posthog.capture('dar_reminder_dismissed');
    }

    function startClock() {
        setTimeout(() => {
            function tick() {
                time = DateTime.now();
                timeString = getTimeString();
                dateString = getDateString();

                if (time.minute === 0 && State.options.darNotifications) {
                    if (State.options.notificationPermission && !triggeredNotification) {
                        new Notification("Do your DAR");
                        triggeredNotification = true;
                    }

                    if (!darModal && !triggeredDarModal) {
                        openDarModal();
                        triggeredDarModal = true;
                    }

                } else {
                    triggeredNotification = false;
                    triggeredDarModal = false;
                }

                //* Update time since last counter update
                const lastUpdated = Helper.timeAgo(DateTime.fromISO(State.lastUpdated));
                State.lastUpdatedString = lastUpdated ? lastUpdated : "Never";

                requestAnimationFrame(tick);
            }

            tick();
        }, 1000);
    }

    startClock();
</script>

<DarModal bind:isOpen={darModal} close={closeDarModal}/>

<NotificationModal isOpen={showNotificationsModal}/>

<div class="flex flex-col items-center justify-center w-full h-full relative px-5 vsm:lg:pb-[4.5rem]">
    <Heading
            class="text-5xl v4xs:!text-6xl font-bold flex items-center justify-evenly w-auto frappe:text-ctp-pink black:text-white"
            tag="h2">
        {#each timeString.split('') as char }
            <span class="{char === ':' ? 'w-[0.5ch]' : 'w-[1ch]'} flex items-center justify-center">{char}</span>
        {/each}
    </Heading>
    <Heading
            class="text-xl v4xs:!text-2xl font-bold mt-2 flex items-center justify-center frappe:text-ctp-mauve black:text-white"
            tag="h2">{dateString}</Heading>
</div>